import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { BaseEntityResponseDto } from '@sphere/shared/domain';

export class ActivityCategoryResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  code!: string;

  @ApiProperty({ type: 'string' })
  label!: string;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  description!: string | null;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  icon!: string | null;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  color!: string | null;

  @ApiPropertyOptional({ type: Number, nullable: true, description: 'Durée suggérée (minutes)' })
  suggestedDuration!: number | null;

  @ApiPropertyOptional({ type: Boolean, default: false })
  requiresGrading!: boolean | null;
}

